import Vue from 'vue'
import App from './app.vue'
import '../../style/index.less'

new Vue({
  el: '#app',
  render: h => h(App)
})
